"use client";

import type React from "react";

interface CalendarHourCellProps {
  hour: number;
  isLoading: boolean;
  children?: React.ReactNode;
}

export function CalendarHourCell({ hour, children }: CalendarHourCellProps) {
  return (
    <div
      key={hour}
      className="absolute w-full border-b"
      style={{
        top: `${(hour - 0) * 80}px`, // These will be overridden by the parent's style
        height: "var(--calendar-hour-height)",
      }}
    >
      {children}
    </div>
  );
}
